import api from "./api";
import store from "@/store";
import { USER_ROLES } from "@/services/constants";

const userService = {};
const endpoint = () => `/users`;

userService.create = function (user) {
  return api.post(endpoint(), user);
};

userService.get = function (query) {
  return api
    .get(endpoint(), {
      params: { ...query, sort: { lastName: 1, firstName: 1 } },
    })
    .then((res) => res.data);
};

userService.getDoctors = function (query = {}) {
  return userService.get({
    ...query,
    roles: [USER_ROLES.DOCTOR.id],
    sort: { lastName: 1, firstName: 1 },
  });
};

userService.getDoctorsByInstitution = function (institutionId) {
  return api
    .get(`doctors/institution/${institutionId}`, {
      params: { sort: { lastName: 1, firstName: 1 } },
    })
    .then((res) => res.data);
};

userService.getManagers = function (query = {}) {
  return userService.get({
    ...query,
    roles: [USER_ROLES.MANAGER.id],
    sort: { lastName: 1, firstName: 1 },
  });
};

userService.getById = function (id) {
  return api.get(`${endpoint()}/${id}`).then((res) => res.data);
};

userService.update = function (userFormData) {
  const userId = userFormData.get("_id");
  return api.put(`${endpoint()}/${userId}`, userFormData);
};

/**
 * @description Actualiza campos del usuario autenticado via PUT /users/me.
 * Solo acepta campos seguros (email, phone, governmentId, doctor.description).
 * Mergea la respuesta con el usuario existente en el store para no perder
 * campos que no devuelve el backend (role display, permissions, etc).
 * @param {Object} payload - Campos a actualizar
 * @returns {Promise<void>}
 */
userService.updateMe = function (payload) {
  return api.put(`${endpoint()}/me`, payload).then(() => {
    const existing = store.state.user;
    store.commit("setUser", { ...existing, ...payload });
  });
};

userService.updatePassword = function (user) {
  return api.put(`/users/${user._id}/password-reset`, user);
};

/**
 * @description UC-REG-096 — Envía email de "blanquear clave" al usuario.
 *              El backend ya tiene PUT /:username/password-reset que genera
 *              un passwordResetToken nuevo y manda email con el link para
 *              que el usuario fije una clave nueva.
 * @param {string} username
 * @returns {Promise<void>}
 */
userService.sendPasswordReset = function (username) {
  return api.put(`${endpoint()}/${username}/password-reset`);
};

userService.lock = function (id) {
  return api.put(`${endpoint()}/${id}/lock`);
};

userService.unlock = function (id) {
  return api.put(`${endpoint()}/${id}/unlock`);
};

userService.delete = function (id) {
  return api.delete(`${endpoint()}/${id}`);
};

userService.updateSelectedBox = function (userId, boxId) {
  return api
    .put(`${endpoint()}/${userId}/selected-box`, { boxId })
    .then((res) => res.data);
};

export default userService;
